import { cn } from 'lib/utils';

const Divider = ({ className }) => {
  return (
    <hr
      className={cn(
        'my-10 h-px border-0 bg-stone-200 dark:bg-stone-700',
        className
      )}
    />
  );
};

export default Divider;
